// extracted by mini-css-extract-plugin
export var card = "card-module--card--551c7";
export var card__black = "card-module--card__black--2e87b";
export var card__bloodorange = "card-module--card__bloodorange--7277d";
export var card__chartruse = "card-module--card__chartruse--24619";
export var card__cobalt = "card-module--card__cobalt--fc17c";
export var card__emerald = "card-module--card__emerald--68992";
export var card__link = "card-module--card__link--14613";
export var card__paper = "card-module--card__paper--84ff5";
export var card__pink = "card-module--card__pink--6c979";
export var card__primary = "card-module--card__primary--6a8d6";
export var card__secondary = "card-module--card__secondary--21134";
export var card__sky = "card-module--card__sky--93e24";
export var card__tertiary = "card-module--card__tertiary--ec6d5";
export var card__white = "card-module--card__white--d0be1";
export var content = "card-module--content--b7e9c";
export var content__blankImage = "card-module--content__blankImage--28ea5";
export var content__primary = "card-module--content__primary--5f62f";
export var content__tertiary = "card-module--content__tertiary--40337";
export var emoji = "card-module--emoji--0f718";
export var emojis = "card-module--emojis--c5dbe";
export var image = "card-module--image--aed07";
export var imageWrap__tertiary = "card-module--imageWrap__tertiary--4f4ed";
export var image__primary = "card-module--image__primary--1e2ad";
export var image__tertiary = "card-module--image__tertiary--e2fec";
export var spin = "card-module--spin--066fa";
export var storyType = "card-module--storyType--b2300";
export var title = "card-module--title--3b2e1";
export var title__multisport = "card-module--title__multisport--81d4a";
export var title__tertiary = "card-module--title__tertiary--df165";